import axios from "axios";
import { handleSuccessOne, handleErrorOne } from "@store/action/GlobalAction";

const URL = process.env.REACT_APP_MICRO_MULTIMEDIA_URL;

export const getAllPlaylists = (params) => async (dispatch) => {
  await axios
    .get(`${URL}/playlists/radio${params.search ? params.search : ""}`, {
      params: {
        per_page: params.per_page,
        page: params.page,
      },
    })
    .then((response) => {
      dispatch({
        type: "GET_ALL_PLAYLIST",
        data: response.data.data.data,
        totalPages: response.data.data.total,
        params,
      });
    });
};
export const getAllPlaylistsByCategory =
  (category_id, params) => async (dispatch) => {
    await axios
      .get(
        `${URL}/playlists/radio/category/${category_id}${
          params.search ? params.search : ""
        }`,
        {
          params: {
            per_page: params.per_page,
            page: params.page,
          },
        }
      )
      .then((response) => {
        dispatch({
          type: "GET_ALL_PLAYLIST_BY_CATEGORY",
          data: response.data.data.data,
          totalPages: response.data.data.total,
          params,
        });
      });
  };
export const getCategoryBy_id = async (category_id) => {
  const res = await axios.get(`${URL}/categories/${category_id}`);
  const category = res.data.data;
  return category;
};
export const getPlaylistById = (id) => async (dispatch) => {
  await axios.get(`${URL}/playlists/${id}`).then((response) => {
    dispatch({
      type: "GET_PLAYLIST_BY_ID",
      data: response.data.data,
    });
  });
};
export const addPlaylist = (files, func, params) => async (dispatch) => {
  const formData = new FormData();
  formData.append("name", files.name);
  formData.append("description", files.description);
  formData.append("radio_id", files.radio_id);
  formData.append("picture", files.picture);
  formData.append("is_public", files.is_public);
  //categorie_ids
  for (let i = 0; i < files.categorie_ids.length; i++) {
    formData.append("categorie_ids[]", files.categorie_ids[i]);
  }
  //tag_ids
  for (let i = 0; i < files.tag_ids.length; i++) {
    formData.append("tag_ids[]", files.tag_ids[i]);
  }
  //media_ids
  for (let i = 0; i < files.media_ids.length; i++) {
    formData.append("media_ids[]", files.media_ids[i]);
  }

  await axios
    .post(`${URL}/playlists`, formData)
    .then((res) => {
      dispatch({
        type: "ADD_PLAYLIST_SUCCESS",
        payload: res.data,
      });
      func();
      handleSuccessOne(res.data.message);
      dispatch(getAllPlaylists(params));
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "ADD_PLAYLIST_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "ADD_PLAYLIST_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const editPlayList = (id, info, func, params) => async (dispatch) => {
  const data = new FormData();
  data.append("name", info.name);
  data.append("description", info.description);
  data.append("radio_id", info.radio_id);
  data.append("is_public", info.is_public);
  data.append("_method", "PUT");

  for (let i = 0; i < info.categorie_ids.length; i++) {
    data.append("categorie_ids[]", info.categorie_ids[i]);
  }
  for (let i = 0; i < info.tag_ids.length; i++) {
    data.append("tag_ids[]", info.tag_ids[i]);
  }
  for (let i = 0; i < info.media_ids.length; i++) {
    data.append("media_ids[]", info.media_ids[i]);
  }
  info.picture && data.append("picture", info.picture);

  await axios
    .post(`${URL}/playlists/${id}`, data)
    .then((response) => {
      dispatch({
        type: "EDIT_PLAYLIST_SUCCESS",
        message: response.data.message,
      });
      func();
      handleSuccessOne(response.data.message);
      dispatch(getAllPlaylists(params));
    })
    .then((res) => {
      dispatch({
        type: "END_EDIT_PLAYLIST",
      });
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "EDIT_PLAYLIST_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "EDIT_PLAYLIST_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const deletePlaylist = (id, params) => async (dispatch) => {
  axios
    .delete(`${URL}/playlists/${id}`)
    .then((res) => {
      if (res.data.code === 200) {
        handleSuccessOne(res.data.message);
        dispatch(getAllPlaylists(params));
      }
    })
    .catch((err) => {
      if (err.response) {
        handleErrorOne(err.response.data.message);
      }
    });
};

export const getCommentByPlaylistId = (id) => async (dispatch) => {
  axios
    .get(`${URL}/playlist/comment/${id}?per_page=all`)
    .then((response) => {
      dispatch({
        type: "GET_COMMENT_BY_PLAYLIST",
        Comments: response.data.data.data,
        totalPages: response.data.data.total,
      });
    })
    .catch(() => {
      dispatch({
        type: "GET_COMMENT_BY_PLAYLIST",
        Comments: [],
        totalPages: 0,
      });
    });
};
export const addCommentByPlaylist = (data, id, func) => async (dispatch) => {
  axios
    .post(`${URL}/playlist/comment/${id}`, data)
    .then((res) => {
      dispatch({
        type: "ADD_COMMENT_PLAYLIST_SUCCESS",
        payload: res.data,
      });
      func();
      handleSuccessOne(res.data.message);
      dispatch(getCommentByPlaylistId(id));
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "ADD_COMMENT_PLAYLIST_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "ADD_COMMENT_PLAYLIST_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const getAllPlaylistComments = (params) => async (dispatch) => {
  await axios
    .get(
      `${URL}/playlist/all-comments/${params?.per_page}?page=${params?.page}`
    )
    .then((response) => {
      dispatch({
        type: "GET_ALL_PLAYLIST_COMMENTS",
        data: response.data.data?.data,
        totalPages: response.data.data?.total,
      });
    });
};

export const EditStatusComment =
  (idpo, idcom, active, params) => async (dispatch) => {
    const data = {
      active: active,
    };
    axios
      .put(`${URL}/playlist/comment/${idpo}/${idcom}`, data)
      .then((response) => {
        dispatch({
          type: "EDIT_STATUS_COMMENT_PLAYLIST_SUCCESS",
          payload: response.data,
        });
        {
          active === 0
            ? handleSuccessOne("comment status switched to Drafted ")
            : handleSuccessOne("comment status switched to Published");
        }
        dispatch(getAllPlaylistComments(params));
      })
      .catch((err) => {
        if (err.response) {
          dispatch({
            type: "EDIT_STATUS_COMMENT_PLAYLIST_FAIL",
            payload: err.response.data.message,
          });
          setTimeout(() => {
            dispatch({
              type: "EDIT_STATUS_COMMENT_PLAYLIST_FAIL",
              payload: null,
            });
          }, 3000);
        }
      });
  };
export const getLastPlaylist = () => async (dispatch) => {
  axios.get(`${URL}/playlists/last/5`).then((response) => {
    dispatch({
      type: "GET_LAST_PLAYLIST",
      Last: response?.data?.data,
    });
  });
};
